module.exports = __webpack_public_path__ + "static/media/screen1.d2ca3fbd.png";